import { Form, Row, Col, Alert } from "react-bootstrap";
import Footer from "../../Components/common/Footer";
import Header from "../../Components/common/Header";
import LoginImg from "../../Imge/undraw_login_weas.svg";
import "./Form.css";
import { faEnvelope, faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { baseURL, LOGIN } from "../../API/API";
import Lodingsubmit from "../../Components/Loding/Loding";
import useAuth from "../hooks/useAuth";

export default function Login() {
  const [FormData, SetForm] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [success, SetSuccess] = useState("");
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  function handelChange(e) {
    SetForm({ ...FormData, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${baseURL}/${LOGIN}`, FormData, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      const accessToken = res.data.accessToken;
      const refreshToken = res.data.refreshToken;

      setLoading(false);
      setErr("");
      SetSuccess(res.data?.message || res.data?.Message || "تم تسجيل الدخول بنجاح");

      localStorage.setItem("accessToken", accessToken);
      if (refreshToken) {
        localStorage.setItem("refreshToken", refreshToken);
      }

      // Fetch user data to check if admin and save it immediately
      try {
        const userRes = await axios.get(`${baseURL}/auth/me`, {
          headers: { Authorization: `Bearer ${accessToken}` },
          withCredentials: true,
        });

        const userData = userRes.data?.data ?? userRes.data;
        localStorage.setItem("user", JSON.stringify(userData));
        setAuth({ accessToken, user: userData });

        // Get the original page the user tried to access
        const from = location.state?.from?.pathname || null;
        
        // If user was trying to access a protected page, return to it
        if (from && (from.includes('/learn/') || from.includes('/lesson/') || from.includes('/exam/') || from.includes('/profile'))) {
          navigate(from, { replace: true });
        } else if (userData?.is_staff) {
          navigate("/DashboardLayout", { replace: true });
        } else if (userData?.academic_year_id) {
          navigate(`/learn/${userData.academic_year_id}`, { replace: true });
        } else {
          navigate("/courses/general", { replace: true });
        }
      } catch (err) {
        setAuth({ accessToken });
        const from = location.state?.from?.pathname || null;
        setTimeout(() => {
          if (from && from !== '/login') {
            navigate(from, { replace: true });
          } else {
            navigate("/DashboardLayout", { replace: true });
          }
        }, 800);
      }
    } catch (err) {
      setLoading(false);
      setErr(err?.response?.data?.message || err?.response?.data?.Message || "حدث خطأ، حاول مرة أخرى");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && <Lodingsubmit />}
      <div className="Authpage">
        <Header />
        <Row className="w-100">
          <Col md={4} className="imgform d-none d-md-block p-0">
            <img
              src={LoginImg}
              alt="صورة تسجيل"
              className="img-fluid h-100 w-100"
              style={{ objectFit: "cover" }}
            />
          </Col>
          <Col
            xs={12}
            md={8}
            className="form-contant d-flex align-items-center justify-content-center bg-light"
          >
            <Form className="Form w-75" onSubmit={handleSubmit}>
              <h3 className="titleForm mb-4 text-strart"> تسجيل الدخول: </h3>
              <p className="mb-4">
                ادخل علي حسابك بإدخال البريد الالكتروني و كلمة المرور المسجل بهم من قبل.
              </p>

              <Form.Group className="floating-label-group mb-4">
                <Form.Control
                  placeholder=" "
                  required
                  className="inpoutFeald login-input"
                  type="email"
                  name="email"
                  value={FormData.email}
                  onChange={handelChange}
                />
                <Form.Label>
                  <FontAwesomeIcon className="iconeForm" icon={faEnvelope} />
                  <span className="textinpout">البريد الإلكتروني</span>
                </Form.Label>
              </Form.Group>

              <Form.Group className="floating-label-group mb-4 w-100" style={{ position: "relative" }}>
                <Form.Control
                  placeholder=" "
                  required
                  className={`inpoutFeald login-input ${FormData.password ? 'has-value' : ''}`}
                  style={{ paddingLeft: "40px" }}
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={FormData.password}
                  onChange={handelChange}
                />
                <Form.Label>
                  <FontAwesomeIcon className="iconeForm" icon={faLock} />
                  <span className="textinpout">كلمة السر</span>
                </Form.Label>
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    position: "absolute",
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    padding: 0,
                    color: "var(--nat-600)",
                  }}
                >
                  {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                </button>
              </Form.Group>

              <button type="submit" className="btn_submit btn_small ms-auto">
                تسجيل الدخول
              </button>

              {err && (
                <Alert variant="danger" style={{ marginTop: "20px" }}>
                  {err}
                </Alert>
              )}
              {success && (
                <Alert variant="success" style={{ marginTop: "20px" }}>
                  {success}
                </Alert>
              )}

              <Link to="#" target="_blank" className="btn_square_green">
                طريقة انشاء حساب على نوح اكاديمي
              </Link>
              <div className="mt-4">
                هل نسيت كلمة السر؟
                <Link to="/forget-password" className="text-decoration-none">
                  <span style={{ textDecoration: "underline" }} className="gold">
                    اضغط هنا
                  </span>
                </Link>
              </div>
              <div className="mt-4">
                لا يوجد لديك حساب؟
                <Link to="/register" className="text-decoration-none">
                  <span className="gold"> انشئ حسابك الآن ! </span>
                </Link>
              </div>
            </Form>
          </Col>
        </Row>
        <Footer />
      </div>
    </>
  );
}
